import { Link } from 'react-router-dom';
import './Footer.css';

const cols = [
  { title:'Company',   links:[{l:'About Us',to:'/about#about'},{l:'Careers',to:'/about#careers'},{l:'News',to:'/about#news'},{l:'Contact',to:'/about#contact'}] },
  { title:'Solutions', links:[{l:'Fleet',to:'/fleet'},{l:'Cold Chain',to:'/fleet'},{l:'Technology',to:'/technology'},{l:'Industries',to:'/industries'}] },
  { title:'Resources', links:[{l:'Blog',to:'/'},{l:'FAQs',to:'/contact'},{l:'Case Studies',to:'/'},{l:'Support',to:'/contact'}] },
  { title:'Investors', links:[{l:'Investment Overview',to:'/'},{l:'Pitch Deck',to:'/'},{l:'Partner With Us',to:'/contact'},{l:'Contact IR',to:'/contact'}] },
];

export default function Footer() {
  return (
    <footer>
      <div className="footer-inner">
        <div className="footer-brand">
          <img src="/axion-logo.png" alt="Axion Mobility" className="footer-logo" />
          <p className="footer-tagline">
            Axion Mobility is an EV logistics platform providing subscription fleet management and sustainable green logistics across Asia.
          </p>
          <div className="footer-social">
            <a href="https://www.linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn">in</a>
            <a href="https://www.facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook">f</a>
            <a href="https://www.youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube">▶</a>
            <a href="mailto:dev@akkra.co.th" aria-label="Email">✉</a>
          </div>
        </div>
        {cols.map(col => (
          <div key={col.title} className="footer-col">
            <h4 className="footer-col-title">{col.title}</h4>
            <ul>
              {col.links.map(({ l, to }) => (
                <li key={l}><Link to={to}>{l}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Axion Mobility. All rights reserved.</span>
        <div className="footer-bottom-links">
          <Link to="/about">Privacy Policy</Link>
          <Link to="/about">Terms of Use</Link>
        </div>
      </div>
    </footer>
  );
}
